module.exports = __webpack_public_path__ + "static/haus_4k-89e3dfe6ffed0e55c0932296f97872ce.jpg";